import { useMemo } from 'react';

import { useParams } from '../../container/Router';

export const useIsAcademy = () => {
    const { redirect_uri } = useParams();

    return useMemo(() => redirect_uri?.includes('academy'), [ redirect_uri ]);
};
